<template>
  <div class="bbe-templates"
       ref="bbeTemplates"
       @dragend="dragEndInFolder"
       @dragleave="draggedActive = ''"
       @dragenter="dragMove"
       @dragover="dragMove">
    <div class="bbe-templates-header">
      <div class="bbe-templates-header__path">
        <div class="bbe-templates-header__item"
             :class="{
            'bbe-templates-header__item_active': index === foldersPaths.length - 1,
            'bbe-templates-header__item_home': index === 0
           }"
             @click="pushToFolder(folder)"
             v-for="(folder,index) in foldersPaths"
             :key="folder.id || index"
             data-type="foldersList">
          <i class="email-icon-home bbe-templates-header__icon bbe-templates-header__icon_home"
             :class="{'bbe-templates-header__to-drag': draggedActive === (index === 0 ? 'main' : folder.id)}"
             v-if="index === 0" :data-id="index === 0 ? 'main' : folder.id" data-type="foldersList"/>
          <i class="email-icon-next-1 bbe-templates-header__icon"
             :class="{'bbe-templates-header__icon_active': index === foldersPaths.length - 1}"
             v-if="index > 0"/>
          <span :data-id="index === 0 ? 'main' : folder.id" data-type="foldersList"
                :class="{'bbe-templates-header__to-drag': draggedActive === (index === 0 ? 'main' : folder.id)}">
          {{ hideHomeText(index) ? '' : folder.name }}
        </span>
        </div>
      </div>
      <div class="bbe-templates-header-sort"
           @click="changeStatusSortByName"
           :class="{
             'bbe-templates-header-sort_active': sortByName.asc || sortByName.desc
           }">
        <span>A-Z</span>
        <i class="email-icon-up-arrow bbe-templates-header-sort__icon"
           :class="{
             'bbe-templates-header-sort__icon_down': sortByName.desc
           }"/>
      </div>
    </div>
    <VuePerfectScrollbar class="bbe-templates-body"
                         ref="bbeTemplatesBody"
                         v-if="!loaderRun">
      <draggable tag="div"
                 v-for="list in lists"
                 :key="list.id"
                 v-model="list.context"
                 v-bind="dragOptions(list)"
                 @start="draggable = true"
                 @end="dragEnd($event, list)">
        <transition-group tag="div" type="transition" name="bbe-flip-list">
          <div class="bbe-templates-body-item"
               :class="{'bbe-templates-body-item__template': !getProp(template, '$info.isFolder')}"
               :draggable="true"
               @dragstart="templateDragStart($event, template)"
               v-for="(template, index) in list.context"
               v-if="!(template.fromMail && foldersPaths.length > 1)"
               :key="template.id"
               :id="template.id"
               @click="openTemplate({viewMode: true, template: template})"
               @mouseenter="setActiveTemplate(template)"
               @mouseleave="removeActiveTemplate()">
            <div class="bbe-templates-body-item__container"
                 :class="{'bbe-templates-body-item__container_no-border': index === 0 && list.id === 'foldersList'}">
              <div class="bbe-templates-body-item-drag">
                <transition name="bbe-bounce">
                  <i class="email-icon-drag bbe-templates-body-item-drag__icon"
                     v-if="activeTemplate.id === template.id && !draggable && !sortByName.asc && !sortByName.desc"/>
                </transition>
              </div>
              <div class="bbe-templates-body-item__info"
                   :class="{'bbe-templates-body-item__info_hover': draggedActive === template.id}">
                <div class="bbe-templates-body-item-image"
                     :class="{
                       'bbe-templates-body-item-image_notification': checkNotification(template),
                       'bbe-templates-body-item-image_notification_template': !getProp(template, '$info.isFolder')
                     }">
                  <img class="bbe-templates-body-item-image__icon"
                       :data-type="list.id"
                       :data-id="template.id"
                       draggable="false"
                       :src="getProp(template, '$info.icon')"/>
                  <div class="bbe-templates-body-item-image__count"
                       v-if="list.id === 'foldersList' && template.templatesCount">
                    {{template.templatesCount}}
                  </div>
                </div>
                <div class="bbe-templates-body-item-data">
                  <div class="bbe-templates-body-item-data-name">
                    <div class="bbe-templates-body-item-data-name__text">{{ template.name }}</div>
                  </div>
                  <div class="bbe-templates-body-item-data-dates" v-if="!getProp(template, '$info.isFolder')">
                    <div class="bbe-templates-body-item-data-dates-item" v-if="template.createdAt">
                      <i class="email-icon-checkmark bbe-templates-body-item-data-dates-item__icon"/>
                      {{ formatDate(template.createdAt) }}
                    </div>
                    <div class="bbe-templates-body-item-data-dates-item" v-if="template.updatedAt">
                      <i class="email-icon-edited bbe-templates-body-item-data-dates-item__icon"/>
                      {{ formatDate(template.updatedAt) }}
                    </div>
                  </div>
                </div>
                <TemplatesPreview
                  :content="activeTemplate.highlightContent? activeTemplate.highlightContent[0]: activeTemplate.content"
                  :position="previewCoordinates"
                  v-if="checkedPreview(template)"
                  @mouseenter="viewPreview = true"
                  @mouseleave="viewPreview = false"
                  @close="viewPreview = false"/>
              </div>
              <transition name="bbe-fade-options">
                <ToolbarTemplate class="bbe-templates-body-item__toolbar"
                                 :template="template"
                                 v-if="activeTemplate.id === template.id && !draggable"
                                 :access="getProp(template, '$info.toolbar.access')"
                                 :edit="getProp(template, '$info.toolbar.edit')"
                                 :delete="getProp(template, '$info.toolbar.delete')"
                                 :view="getProp(template, '$info.toolbar.view')"
                />
              </transition>
            </div>
          </div>
        </transition-group>
      </draggable>
    </VuePerfectScrollbar>
    <div class="bbe-templates-controls" :class="{'bbe-templates-controls_hide': viewPreview}">
      <transition-group tag="div"
                        name="bbe-list-complete"
                        class="bbe-templates-controls__main-controls">
        <button class="bbe-button bbe-templates-controls__add-template"
                v-if="openControls"
                :key="'new-template'"
                @click="openTemplate({viewMode: false, template: {}})">
          New template
        </button>
        <i class="email-icon-add-folder bbe-templates-controls__add-folder"
           v-if="openControls && !hideAddFolder"
           :key="'new-folder'"
           @click.stop="openModal(1)"/>
        <i
          v-if="getUserId() && openControls"
          class="email-icon-plus bbe-button-new-message bbe-button-new-message_template"
          :key="'new-mail'"
          @click.stop="openNewMessage()"
        />
      </transition-group>
      <transition-group tag="div"
                        name="bbe-list-complete"
                        class="bbe-templates-controls__display-controls"
                        :class="{'bbe-templates-controls__display-controls_open': openControls}">
        <i class="email-icon-plus bbe-templates-controls__icon"
           :key="'close'"
           v-if="openControls"
           @click="openControls = false"/>
        <i class="email-icon-options bbe-templates-controls__icon"
           :key="'open'"
           v-else
           @click="openControls = true"/>
      </transition-group>
    </div>
    <transition name="bbe-fade">
      <ModalWindow v-if="openModalWindow"
                   :title="titleModal"
                   :rightButton="rightButton"
                   @close="openModalWindow = false">
        <transition name="bbe-bounce">
          <span v-if="error" class="bbe-templates__form-error bbe-label bbe-label__error">{{ error }}</span>
        </transition>
        <template v-if="openModalWindow === 1 || openModalWindow === 2">
          <NewFolderForm :folder="folder" :rightAction="rightButtonAction" :parentFolder="lastFolder"/>
        </template>
        <template v-else-if="openModalWindow === 3 || openModalWindow === -3">
          <DeleteFolderForm :target="targetTemplate"/>
        </template>
        <template v-else-if="openModalWindow === 4">
          <ConfigureAccess :template="targetTemplate" @changeValue="configureAccess"/>
        </template>
      </ModalWindow>
    </transition>
    <transition name="bbe-routing-fade" appear>
      <SendingStatus v-if="errorMessage" :errorText="errorMessage" :close="hideError"/>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import icons from '@/constants/images'
import ToolbarTemplate from '@/components/Templates/TemplatesSidebar/ToolbarTemplate'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import foldersApi from '@/api/Folders/api'
import {get, findIndex, cloneDeep, find, last, orderBy, groupBy} from 'lodash'
import {FOUNDER, ROLES_LIST} from '@/constants/roles'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import templatesApi from '@/api/Templates/api'
import ConfigureAccess from '@/components/Templates/TemplatesSidebar/ConfigureAccess'
import signatureGenerator from '@/mixin/signatureGenerator'
import signatureGeneratorType2 from '@/mixin/signatureGeneratorType2'
import TemplatesPreview from '@/components/Templates/TemplatesPreview/TemplatesPreview'
import draggable from 'vuedraggable'
import routerPush from '@/mixin/routerPush'
import NewFolderForm from '@/components/Templates/TemplatesSidebar/FolderForm/NewFolderForm'
import DeleteFolderForm from '@/components/Templates/TemplatesSidebar/FolderForm/DeleteFolderForm'
import folderTypes from '@/constants/folderTypes'
import SendingStatus from '@/components/Main/SendingStatus/SendingStatus'
import getErrorMessage from '@/mixin/getErrorMessage'

export default {
  name: 'TemplatesSidebar',
  mixins: [signatureGenerator, signatureGeneratorType2, routerPush, getErrorMessage],
  components: {
    ConfigureAccess,
    ToolbarTemplate,
    VuePerfectScrollbar,
    ModalWindow,
    LoaderFly,
    TemplatesPreview,
    draggable,
    NewFolderForm,
    DeleteFolderForm,
    SendingStatus
  },
  data () {
    return {
      sortByName: {
        asc: false,
        desc: false
      },
      openControls: true,
      lastCoordinates: {x: 0, y: 0},
      draggable: false,
      error: false,
      loaderRun: false,
      activeTemplate: {},
      viewPreview: false,
      previewCoordinates: {},
      targetTemplate: false,
      openModalWindow: false,
      rightButtonText: '',
      rightButtonAction: false,
      titleModal: '',
      propsTemplates: {},
      foldersPaths: [
        {
          name: 'Templates',
          id: ''
        }
      ],
      folder: {
        name: '',
        roles: ROLES_LIST.map(item => item.id)
      },
      targetDrag: '',
      draggedActive: '',
      errorMessage: '',
      notifyForSystem: false,
      checkedUserId: []
    }
  },
  computed: {
    lists () {
      return [
        {
          id: 'foldersList',
          context: this.getList(this.foldersList)
        },
        {
          id: 'templatesList',
          context: this.getList(this.templatesList)
        }
      ]
    },
    searchStore () {
      return this.$store.getters.search
    },
    rightButton () {
      return {
        text: this.rightButtonText,
        action: this.rightButtonAction
      }
    },
    activeUser () {
      return this.$store.getters.userInfo || this.$store.getters.activeUser
    },
    isFounder () {
      return get(this.activeUser, 'role', '') === FOUNDER.id
    },
    newMessage: {
      get: function () {
        return this.$store.getters.newMessage
      },
      set: function (data) {
        this.$store.dispatch('setNewMessage', data)
      }
    },
    templatesList: {
      get: function () {
        return this.$store.getters.templatesList
      },
      set: function (data) {
        this.$store.dispatch('setTemplatesList', data)
      }
    },
    foldersList: {
      get: function () {
        return this.$store.getters.foldersList
      },
      set: function (data) {
        this.$store.dispatch('setFoldersList', data)
      }
    },
    currentFolder: {
      get: function () {
        return this.$store.getters.currentFolder
      },
      set: function (data) {
        this.$store.dispatch('setCurrentFolder', data)
      }
    },
    currentTemplate: {
      get: function () {
        return this.$store.getters.currentTemplate
      },
      set: function (data) {
        this.$store.dispatch('setCurrentTemplate', data)
      }
    },
    draggedTemplate: {
      get: function () {
        return this.$store.getters.draggedTemplate
      },
      set: function (data) {
        this.$store.dispatch('setDraggedTemplate', data)
      }
    },
    hideAddFolder () {
      const folder = this.lastFolder
      const isPersonalFolder = folder.typeFolder === folderTypes.PERSONAL_FOLDER
      return (this.isSystemFolder(folder) && !this.isFounder) || isPersonalFolder
    },
    activeTab () {
      return this.$store.getters.activeTab
    },
    lastFolder () {
      return last(this.foldersPaths) || {}
    }
  },
  methods: {
    hideError () {
      this.errorMessage = ''
    },
    setDefaultFolder () {
      this.folder = {
        name: '',
        roles: ROLES_LIST.map(item => item.id)
      }
    },
    formatDate (date) {
      const momentDate = moment(date)
      const isValid = momentDate.isValid()
      return isValid ? momentDate.format('DD.MM.YYYY') : ''
    },
    getList (list) {
      if (this.sortByName.asc || this.sortByName.desc) {
        const groupByLang = groupBy(list, item => {
          const name = item.name.toLowerCase()
          return name.search(/[а-яё]/g) > -1
        })
        const sortingOrder = this.sortByName.asc ? 'acs' : 'desc'
        const sortRu = orderBy(groupByLang.true, ['name'], [sortingOrder])
        const sortEng = orderBy(groupByLang.false, ['name'], [sortingOrder])
        return sortRu.concat(sortEng)
      }
      return orderBy(list, ['position'], ['asc'])
    },
    dragOptions (list) {
      return {
        handle: '.bbe-templates-body-item-drag',
        animation: 200,
        group: list.id,
        disabled: false,
        ghostClass: 'ghost-draggable'
      }
    },
    dragEndInFolder (e) {
      const x = e.clientX || this.lastCoordinates.x
      const y = e.clientY || this.lastCoordinates.y
      const idTarget = e.target.id
      const indexFolder = findIndex(this.foldersList, {id: idTarget})
      const indexTemplate = findIndex(this.templatesList, {id: idTarget})
      const isFolder = indexFolder !== -1
      const elem = document.elementFromPoint(x, y)
      const newParentFolder = elem.dataset.id
      const result = {
        id: idTarget,
        newParentFolder: newParentFolder
      }
      if (!idTarget || !newParentFolder) return
      if (result.newParentFolder === 'main') delete result.newParentFolder
      const parentTemplate = findIndex(this.templatesList, {id: newParentFolder})
      if (parentTemplate !== -1 || idTarget === newParentFolder) return
      this.updateParent(result, isFolder, {indexTemplate, indexFolder})
    },
    dragMove (e) {
      const x = e.clientX
      const y = e.clientY
      this.lastCoordinates = {
        x: x,
        y: y
      }
      const elem = document.elementFromPoint(x, y)
      if (elem.dataset.type === 'foldersList' && this.draggedActive !== elem.dataset.id) {
        this.draggedActive = elem.dataset.id
      }
    },
    dragEnd (e, list) {
      this.addDragend()
      this.activeTemplate = {}
      this.draggable = false
      const isFolder = list.id === 'foldersList'
      const parentFolder = this.lastFolder.id || ''
      const id = e.item.id
      const body = { id: id }
      if (parentFolder) {
        body.newParentFolder = parentFolder
      }
      body.newPosition = e.newIndex
      this.updatePosition(body, isFolder)
    },
    updateParent (template, isFolder, {indexTemplate, indexFolder}) {
      const promise = isFolder ? foldersApi.updateParent(template) : templatesApi.updateParent(template)
      promise.then(() => {
        if (indexTemplate !== -1) {
          this.templatesList.splice(indexTemplate, 1)
        } else if (indexFolder !== -1) {
          this.foldersList.splice(indexFolder, 1)
        }
      })
        .catch(err => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    sortByPosition (template, isFolder) {
      if (isFolder) {
        this.foldersList = orderBy(this.foldersList, ['position'], ['asc'])
      } else {
        this.templatesList = orderBy(this.templatesList, ['position'], ['asc'])
      }
    },
    updatePosition (template, isFolder) {
      const promise = isFolder ? foldersApi.updatePosition(template) : templatesApi.updatePosition(template)
      promise.then((resp) => {
        return resp
      })
        .catch(err => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
          this.sortByPosition(template, isFolder)
        })
    },
    scrollTop () {
      const refs = this.$refs
      this.$nextTick(() => {
        const scroll = get(refs, 'bbeTemplatesBody.$el', false)
        if (scroll) {
          scroll.scrollTop = 0
        }
      })
    },
    getUserId () {
      return get(this.activeUser, 'gmail.email', '')
    },
    checkedPreview (template) {
      const isHover = this.activeTemplate.id === template.id
      const hasContent = this.activeTemplate.content
      return isHover && hasContent && this.viewPreview
    },
    setPreview (e) {
      this.viewPreview = true
      this.previewCoordinates = e.target.getBoundingClientRect()
    },
    setActiveTemplate (template) {
      this.activeTemplate = template
    },
    removeActiveTemplate () {
      this.viewPreview = false
      this.activeTemplate = {}
    },
    openNewMessage () {
      this.newMessage = {}
      const params = {
        photo: get(this.activeUser, 'image.path', ''),
        username: get(this.activeUser, 'username', ''),
        position: get(this.activeUser, 'position.name', ''),
        phone: get(this.activeUser, 'phone', ''),
        email: get(this.activeUser, 'email', '')
      }
      const { signatureType = 1 } = this.currentCompany
      this.newMessage.contents = signatureType === 1
        ? this.generateSignature(params)
        : this.generateSignatureType2(params)
      const tabName = this.activeTab.toLowerCase()
      this.routerPush({name: 'TabOpen', params: {tab: tabName}})
      this.$set(this.newMessage, 'openFullSize', true)
    },
    checkAccess (template) {
      const userCreate = this.isFolder(template) ? 'userCreateFolder' : 'userCreateTemplate'
      const isPersonalFolder = template.typeFolder === folderTypes.PERSONAL_FOLDER
      const owner = template[userCreate] === this.activeUser.id && !isPersonalFolder
      return (this.isFounder || owner) && !this.isSystemFolder(template)
    },
    changeStatusSortByName () {
      const sortDisabled = !this.sortByName.asc && !this.sortByName.desc
      if (sortDisabled) {
        this.sortByName = {
          asc: true,
          desc: false
        }
      } else if (this.sortByName.asc) {
        this.sortByName = {
          asc: false,
          desc: true
        }
      } else {
        this.sortByName = {
          asc: false,
          desc: false
        }
      }
    },
    hideHomeText (index) {
      const length = this.foldersPaths.length
      const active = length - 1
      return index === 0 && index !== active && length > 0
    },
    isSystemFolder (template) {
      return template.typeFolder === folderTypes.EMPLOYEE_FOLDER
    },
    templateDragStart (e, template) {
      if (this.isSystemFolder(template)) return
      const checkOldDraggable = document.getElementById('old-dragged')
      if (checkOldDraggable) {
        checkOldDraggable.remove()
      }
      const content = template.content
      const files = template.uploadFile
      e.dataTransfer.setData('text/html', content)
      e.dataTransfer.effectAllowed = 'copy'
      const crt = this.createNodeForDrag(e, content, files)
      e.dataTransfer.setDragImage(crt, 0, 0)
      if (template.$info.isFolder) {
        document.addEventListener('dragend', this.addDragend, false)
      }
    },
    createNodeForDrag (e, content, files) {
      const previewTemplate = document.getElementById('previewTemplate')
      if (previewTemplate) {
        previewTemplate.remove()
      }
      const wrapper = document.createElement('div')
      const elem = e.target.cloneNode(true)
      wrapper.appendChild(elem)
      document.body.appendChild(wrapper)
      wrapper.classList.add('dragged-template')
      wrapper.id = 'old-dragged'
      this.targetDrag = wrapper
      this.draggedTemplate = {
        target: elem,
        start: true,
        content: content,
        callback: this.addDragend,
        uploadFiles: files
      }
      return wrapper
    },
    addDragend () {
      if (this.targetDrag) {
        this.targetDrag.style.display = 'none'
        this.targetDrag.remove()
      }
      document.removeEventListener('dragend', this.addDragend, false)
    },
    getFoldersWithTemplates ({parentId, template}) {
      this.loaderRun = true
      const options = {
        parentId: parentId || '',
        template: template || ''
      }
      this.getFolders(options)
      this.getTemplates(options)
    },
    getFolders ({parentId, template}) {
      this.foldersList = []
      foldersApi.getFolder({parentId})
        .then(resp => {
          this.notifyForSystem = resp.data.notify
          this.foldersList = resp.data.folders
          this.setFoldersPaths(template)
          this.loaderRun = false
        })
        .catch(err => {
          this.loaderRun = false
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    getTemplates ({parentId, template}) {
      this.templatesList = []
      templatesApi.getTemplates({parentId})
        .then(resp => {
          this.templatesList = resp.data.templates
          this.setFoldersPaths(template)
        })
        .catch(err => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    searchTemplates ({keywords}) {
      const parentId = this.lastFolder.id
      templatesApi.searchTemplates({keywords, parentId})
        .then(resp => {
          const templates = resp.data.templates.map(template => {
            template.highlightContent = get(template.highlight, 'content.ngram',
              template.highlight === undefined ? template.content : template.highlight.content)
            template.highlightName = get(template.highlight, 'name.ngram',
              template.highlight === undefined ? template.content : template.highlight.name)
            return template
          })
          this.templatesList = templates
        })
        .catch(err => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    setFoldersPaths (template = {}) {
      const parentId = template.id || ''
      const index = findIndex(this.foldersPaths, {id: parentId})
      const insideFolder = index !== -1
      if (!parentId) {
        this.foldersPaths = this.foldersPaths.splice(0, 1)
      } else if (parentId && !insideFolder) {
        this.foldersPaths.push(template)
      } else {
        this.foldersPaths = this.foldersPaths.splice(0, index + 1)
      }
    },
    createFolder () {
      if (!this.folder.name) {
        this.error = 'Folder name can\'t be blank'
        return
      }
      this.loaderRun = true
      this.folder.dateCreateFolder = new Date()
      this.folder.parentFolder = this.getParentId()
      if (this.activeUser.role === FOUNDER.id) {
        this.folder.roles = [FOUNDER.id]
      }
      foldersApi.createFolder(this.folder)
        .then(resp => {
          this.loaderRun = false
          this.openModalWindow = false
          this.foldersList.push(resp.data)
          this.setDefaultFolder()
        })
        .catch(err => {
          this.loaderRun = false
          this.error = this.getErrorMessage(err)
          console.error(err)
        })
    },
    deleteTemplate () {
      const id = this.targetTemplate.id
      templatesApi.deleteTemplate(id)
        .then(resp => {
          this.currentTemplate = {}
          const tabName = this.activeTab.toLowerCase()
          this.routerPush({name: 'TabOpen', params: {tab: tabName}})
          const message = cloneDeep(this.newMessage)
          message.openTemplate = false
          this.newMessage = message
          this.afterDelete(id, this.templatesList)
        })
        .catch(err => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    updateFolder (folder) {
      folder.parentFolder = this.getParentId()
      foldersApi.updateFolder(folder)
        .then(resp => {
          const index = findIndex(this.foldersList, {id: folder.id})
          if (index !== -1) this.foldersList.splice(index, 1, resp.data)
          this.openModalWindow = false
          this.setDefaultFolder()
        })
        .catch(err => {
          this.error = this.getErrorMessage(err)
          console.error(err)
        })
    },
    updateNameFolder () {
      const folder = {
        name: this.folder.name,
        id: this.targetTemplate.id
      }
      this.updateFolder(folder)
    },
    updateRolesFolder () {
      const folder = {
        roles: this.folder.roles,
        allowedUsers: this.folder.allowedUsers,
        id: this.targetTemplate.id
      }
      this.updateFolder(folder)
    },
    deleteFolder () {
      const id = this.targetTemplate.id
      foldersApi.deleteFolder(id)
        .then(resp => {
          this.afterDelete(id, this.foldersList)
        })
        .catch(err => {
          this.error = this.getErrorMessage(err)
          console.error(err)
        })
    },
    afterDelete (id, targetList) {
      this.folder.roles = ROLES_LIST.map(item => item.id)
      this.openModalWindow = false
      const index = findIndex(targetList, {id: id})
      if (index !== -1) targetList.splice(index, 1)
      if (this.$route.params.id === id) {
        const tabName = this.activeTab.toLowerCase()
        this.routerPush({name: 'TabOpen', params: {tab: tabName}})
      }
    },
    getParentId () {
      return this.lastFolder.id || ''
    },
    configureAccess (users) {
      this.folder.allowedUsers = users
    },
    getProp (template, prop) {
      return get(template, prop, '')
    },
    checkNotification (template) {
      const isFolder = this.getProp(template, '$info.isFolder')
      if (isFolder && this.isSystemFolder(template)) return this.isFounder && this.notifyForSystem
      const notify = this.getProp(template, 'notify') || []
      const hasNotify = notify.length > 0
      return this.isFounder && hasNotify
    },
    openTemplate ({viewMode, template}) {
      const isFolder = this.getProp(template, '$info.isFolder')
      if (isFolder) {
        this.currentFolder = cloneDeep(template)
        this.pushToFolder(template)
        return
      }
      const id = get(template, 'id', 'new')
      if (get(this.newMessage, 'openFullSize', false) && id !== 'new') return
      if (template) {
        const newTemplate = cloneDeep(template)
        newTemplate.viewMode = viewMode
        this.currentTemplate = newTemplate
      }
      this.currentTemplate.parentFolder = this.currentTemplate.parentFolder || this.getParentId()
      const params = {id: id}
      this.pushToTemplate(params)
    },
    pushToFolder (template) {
      this.currentFolder = cloneDeep(template)
      const folderId = template.id || ''
      const tabName = this.activeTab.toLowerCase()
      const params = {
        name: 'FolderOpen',
        params: {tab: tabName}
      }
      params.params.path = folderId || ''
      this.routerPush(params)
    },
    pushToTemplate (params) {
      if (this.newMessage === false) return
      const message = cloneDeep(this.newMessage)
      message.openTemplate = true
      message.contentTemplate = false
      if (params.id === 'new' || !this.currentTemplate.viewMode) {
        message.openFullSize = false
      }
      this.newMessage = message
      if (this.$route.params.id !== params.id) {
        this.routerPush({name: 'TemplateOpen', params: params})
      }
    },
    openModal (typeAction) {
      // 1 new; 2 rename; 3 delete; 4 access
      this.error = false
      const isFolder = this.getProp(this.activeTemplate, '$info.isFolder', false) || !this.activeTemplate.id
      const type = isFolder ? typeAction : (typeAction * -1)
      switch (type) {
      case 1:
        this.titleModal = 'Create new folder'
        this.rightButtonText = 'Add'
        this.rightButtonAction = this.createFolder
        this.folder.name = ''
        this.openModalWindow = type
        break
      case 2:
        this.titleModal = 'Rename folder'
        this.rightButtonText = 'Save'
        this.rightButtonAction = this.updateNameFolder
        this.folder = cloneDeep(this.targetTemplate)
        this.openModalWindow = type
        break
      case 3:
        this.titleModal = 'Delete folder?'
        this.rightButtonText = 'Delete'
        this.rightButtonAction = this.deleteFolder
        this.openModalWindow = type
        break
      case 4:
        this.titleModal = 'Configure Access'
        this.rightButtonText = 'Save'
        this.rightButtonAction = this.updateRolesFolder
        this.openModalWindow = type
        break
      case -2:
        this.openTemplate({viewMode: false, template: this.targetTemplate})
        break
      case -3:
        this.titleModal = 'Delete template?'
        this.rightButtonText = 'Delete'
        this.rightButtonAction = this.deleteTemplate
        this.openModalWindow = type
        break
      }
    },
    isFolder (template) {
      return template.hasOwnProperty('typeFolder')
    },
    getIcon (template) {
      return this.isFolder(template) ? icons.folder : icons.template
    },
    closeModalByEsc (event) {
      if (event.keyCode === 27) {
        this.openModalWindow = false
      }
    },
    setTargetTemplate (template) {
      this.targetTemplate = template
    },
    setToolbarOptions (template) {
      return {
        access: {
          visibility: this.isFolder(template) && this.checkAccess(template),
          position: 2,
          action: (template) => {
            this.setTargetTemplate(template)
            this.openModal(4)
          }
        },
        edit: {
          visibility: this.checkAccess(template),
          position: 3,
          action: (template) => {
            this.setTargetTemplate(template)
            this.openModal(2)
          }
        },
        delete: {
          visibility: this.checkAccess(template),
          position: 4,
          action: (template) => {
            this.setTargetTemplate(template)
            this.openModal(3)
          }
        },
        view: {
          visibility: !this.isFolder(template),
          position: 1,
          mouseenter: (e) => {
            this.setPreview(e)
          }
        }
      }
    },
    setOptionsTemplates (target) {
      if (target.length === 0) return
      target.forEach(template => {
        const props = {
          isFolder: this.isFolder(template),
          icon: this.getIcon(template),
          toolbar: this.setToolbarOptions(template)
        }
        template.$info = props
      })
    },
    findTemplateById (id) {
      const templatesWithFolders = this.templatesList.concat(this.foldersList)
      const templateFromHistory = find(this.foldersPaths, {id: id})
      const templateFromStore = find(templatesWithFolders, {id: id})
      return templateFromStore || templateFromHistory
    }
  },
  watch: {
    templatesList () {
      this.scrollTop()
      this.setOptionsTemplates(this.templatesList)
    },
    foldersList () {
      this.scrollTop()
      this.setOptionsTemplates(this.foldersList)
    },
    searchStore (newVal) {
      if (newVal.keywordTemplates) {
        this.foldersList = []
        this.templatesList = []
        setTimeout(() => {
          this.searchTemplates({keywords: newVal.keywordTemplates})
        }, 500)
      } else {
        const folderId = this.lastFolder.id || ''
        const template = this.findTemplateById(folderId)
        this.getFoldersWithTemplates({parentId: folderId, template})
      }
    },
    $route () {
      const folderId = this.$route.params.path
      const templateOpen = this.$route.name !== 'FolderOpen'
      if (templateOpen) return
      if (!folderId) {
        this.getFoldersWithTemplates({})
      } else {
        const template = this.findTemplateById(folderId)
        this.getFoldersWithTemplates({parentId: folderId, template: template})
      }
    }
  },
  mounted () {
    document.addEventListener('keyup', this.closeModalByEsc)
  },
  destroyed () {
    document.removeEventListener('keyup', this.closeModalByEsc)
  },
  beforeMount () {
    this.getFoldersWithTemplates({})
    const tabName = this.activeTab.toLowerCase()
    if (this.$route.params.tab !== tabName || this.$route.params.path) {
      this.routerPush({name: 'TabOpen', params: {tab: tabName}})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-templates {
  @include global-font;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  background-color: $color-white;

  &-header {
    display: inline-grid;
    grid-template-columns: 1fr 53px;
    position: relative;
    padding: 13px 20px;
    min-height: 58px;

    &__path {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    &:after {
      @include line-after-bot
    }

    &__to-drag {
      color: $color-accent
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 7px;
      width: 31px;
      height: 32px;

      &_home {
        font-size: 13px;
      }

      &_active {
        color: $color-accent;
      }
    }

    &__item {
      display: flex;
      align-items: center;
      color: $color-silver-chalice;
      cursor: pointer;
      transition: .2s;
      line-height: 31px;
      z-index: 2;

      &:hover {
        color: $color-accent-hover;
      }

      &_home {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: -12px;
      }

      &_active {
        pointer-events: none;
        color: $color-accent;
      }
    }

    &-sort {
      margin-top: 7px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0;
      margin-left: auto;
      border-left: 1px solid $color-gallery;
      padding-left: 10px;
      color: $color-silver-chalice;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
      transition: 0.2s;
      cursor: pointer;

      &:hover {
        color: $color-dusty-gray;
      }

      &_active {
        color: $color-accent;

        &:hover {
          color: $color-accent-hover;
        }
      }

      &__icon {
        font-size: 10px;
        margin-left: 3px;
        transition: 0.3s;
        transform: rotate(180deg);

        &_down {
          transform: rotate(0deg);
        }
      }
    }
  }

  &-body {
    padding-right: 15px;
    margin-right: -15px;
    padding-bottom: 98px;

    &-item {
      position: relative;
      cursor: pointer;
      transition: .3s;

      &__template {
        cursor: grab;

        &:active {
          cursor: grabbing;
        }
      }

      &:first-child &__container {
        &_no-border {
          border-top-color: transparent;
        }
      }

      &:hover {
        box-shadow: 0 0 25px rgba($color-accent, 0.12);
        border-radius: 8px;
        z-index: 2;
      }

      &:hover &__name {
        color: $color-accent;
      }

      &:hover &__container,
      &:hover + & &__container {
        border-top-color: transparent;
      }

      &-drag {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32px;
        min-width: 32px;
        height: 100%;
        margin-left: -12px;
        cursor: grab;

        &__icon {
          color: $color-dusty-gray;
        }
      }

      &__container {
        display: flex;
        align-items: center;
        margin: 0 22px;
        min-height: 72px;
        border-top: 1px solid $color-wild-sand;
        transition: .3s;
        padding: 21px 0;
      }

      &__info {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;

        &_hover {
          opacity: 0.5;
        }
      }

      &-image {
        width: 30px;
        height: 30px;
        margin-right: 14px;

        &__icon {
          width: 100%;
          height: 100%;
          user-select: none;
        }

        &__count {
          position: absolute;
          left: -8px;
          bottom: -4px;
          border-radius: 13px;
          background-color: $color-link-water;
          color: $color-denim;
          font-weight: 500;
          font-size: 12px;
          line-height: 14px;
          padding: 2px 5px;
        }

        &_notification {
          position: relative;

          &:after {
            position: absolute;
            top: -1px;
            right: -5px;
            content: '';
            width: 12px;
            height: 12px;
            border: 2px solid $color-white;
            box-sizing: border-box;
            border-radius: 50%;
            background-color: $color-pomegranate;
          }

          &_template {
            &:after {
              top: -3px;
              right: 0;
            }
          }
        }
      }

      &-data {

        &-name {
          display: flex;
          align-items: center;

          &__text {
            font-weight: 300;
            color: $color-black;
            font-size: 14px;
            line-height: 17px;
            transition: .2s;
            max-width: 310px;
            word-break: break-word;
          }
        }

        &-dates {
          display: inline-grid;
          grid-template-columns: 1fr 1fr;
          grid-gap: 15px;
          margin-top: 5px;

          &-item {
            color: $color-silver-chalice;
            font-weight: 500;
            font-size: 11px;
            line-height: 13px;

            &__icon {
              font-size: 12px;
            }
          }
        }
      }

      &__toolbar {
        margin-right: 0;
        margin-left: auto;
      }
    }
  }

  &-controls {
    position: absolute;
    bottom: 28px;
    right: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;

    &__main-controls {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &_hide {
      z-index: 0;
    }

    &__add-template {
      font-size: 13px;
      line-height: 15px;
      width: 111px;
      padding: 0;
      box-shadow: 0 0 20px rgba($color-accent, 0.2);
      border-radius: 21px;
      margin-right: 9px;
    }

    &__add-folder {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      width: 42px;
      height: 42px;
      color: $color-white;
      border-radius: 50%;
      background-color: $color-accent;
      cursor: pointer;
      margin-right: 9px;

      &:hover {
        background-color: $color-accent-hover;
      }

      &:active {
        background: $color-accent-pressed;
      }
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 42px;
      height: 42px;
    }

    &__display-controls {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      line-height: 42px;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      background-color: $color-link-water;
      color: $color-accent;
      box-shadow: none;
      cursor: pointer;
      transition: 0.3s;

      &_open {
        transform: rotate(45deg);
      }

      &:hover {
        opacity: 0.8;
        color: $color-accent-hover;
      }
    }
  }

  &__form-error {
    bottom: 19px;
    left: 18px;
    max-width: 238px;
  }
}

</style>

<style lang="scss">
@import "../../../sass/variables";

.bbe-highlight-search {
  background: $color-mercury;
}

.bbe-templates-body {
  .ps__rail-y.ps--clicking .ps__thumb-y, .ps__rail-y:focus > .ps__thumb-y,
  .ps__rail-y:hover > .ps__thumb-y,
  .ps .ps__rail-y .ps__thumb-y, .ps__thumb-y {
    width: 5px;
    background-color: $color-accent;
    z-index: 1;
    right: 10px;
  }

  .ps .ps__rail-y {
    background-color: transparent;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Templates/TemplatesSidebar/TemplatesSidebar.vue